import React from 'react';
import StyledInvolvementSummaryFooter from './StyledInvolvementSummaryFooter';
import {OutputText} from '@ey/canvascoreservices';
import {currentResource} from '../../../../../../../../../util/utils';
import {IconoirTriangle, IconoirCheck} from '@ey-xd/motif-icon';
import {ICON_CIRCLE, ICON_TRIANGLE, ICON_CHECK} from '../../Common/ComponentTableV2/Columns/FormActions/utils/icons';
import {MotifIcon} from '@ey-xd/motif-react';

const InvolvementSummaryFooter = () => {
	const labels = currentResource.groupInvolvement;

	const iconArray = [
		{
			label: labels.involvementTypePlanned
		},
		{
			icon: IconoirTriangle,
			label: labels.significantUpdatesToPlannedInvolvement
		},
		{
			icon: IconoirCheck,
			label: labels.executionComplete
		}
	];

	const handleIcons = (item) => {
		switch (item.label) {
			case labels.involvementTypePlanned:
				return <span className="circle" />;
			case labels.significantUpdatesToPlannedInvolvement:
				return <MotifIcon iconFunction={item.icon} size="16" />;
			case labels.executionComplete:
				return <MotifIcon className="check" iconFunction={item.icon} size="24" />;
			default:
				return <span className="circle" />;
		}
	};

	return (
		<StyledInvolvementSummaryFooter>
			{iconArray.map((item) => {
				return (
					<div className="visual-indicator">
						{handleIcons(item)}
						<OutputText body3 light>
							{item.label}
						</OutputText>
					</div>
				);
			})}
		</StyledInvolvementSummaryFooter>
	);
};

export default InvolvementSummaryFooter;
